module.exports = __webpack_public_path__ + "static/img/v75Bg-p.a1ae79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v75Bg-p.png
// module id = BrUd
// module chunks = 1